/* eslint-disable no-restricted-syntax */
import React, { FC } from "react";
import { ILinkTypeTile } from "./interfaces/ILinkTypeTile";
import classnames from "classnames";
import styles from "./LinkTypeTile.module.css";
import { WhatsappLock } from "features/Integration/modules/IntegrationCard/modules/WhatsappLock/WhatsappLock";

const LinkTypeTile: FC<ILinkTypeTile> = ({
  title,
  description,
  icon,
  active,
  value,
  onClick,
  locked = false,
}) => {
  return (
    <div
      className={classnames(styles.wrapper, active && styles.wrapperActive)}
      onClick={() => onClick(value)}
    >
      <div className={classnames(styles.root, active && styles.active)}>
        <div className={styles.content}>
          <img className={styles.icon} src={icon} alt="" />

          <div className={styles.title}>{title}</div>

          <div className={styles.description}>{description}</div>
          {locked && (
            <div className="tw-absolute tw-top-[6px] tw-right-[6px]">
              <WhatsappLock />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LinkTypeTile;
